import React, { useContext, useEffect, useState } from 'react'
// import dropDownArror from '../../assets/dropdown-svgrepo-com-1@3x.png'
import shoppingCart from '../../assets/cart-svgrepo-com@3x.png'
import handBag from '../../assets/handbag@3x.png'
import historyIcon from '../../assets/history-28-regular@3x.png'
import addIcon from '../../assets/add-address.png'
import editIcon from '../../assets/edit-icon.svg'
import deleteIcon from '../../assets/delete-svgrepo-com-2@3x.png'
import AddAddressModal from './addAddressModal'
import { v4 as uuidv4 } from 'uuid'
import useAxios from 'axios-hooks'
import { UPDATE_USER_INFO, ECOMMERCE_API } from '../../utils/apiUrls'
import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'
import { useNavigate } from 'react-router'
import { raiseToast } from '../../utils/helper'
import ToggleButton from '../../components/toggleButton/toggleButton'

const ManageAddress = () => {
  const { userObj, setLoader, validateSessionCall, accountObj } = useContext(AppContext)
  const [open, setOpen] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [addresses, setAddresses] = useState([])
  const [statesData, setStatesData] = useState([])
  const [editAddress, setEditAddress] = useState({})
  const navigate = useNavigate()
  const isShippingChargesEnabled = accountObj?.od_resource_allowances?.is_shipping_charges_enabled

  const [{ data: updateUserRes, loading: updateUserLoading }, updateUserCall] = useAxios(
    {},
    { manual: true },
  )

  const [{ data: shippingChargesInfo, loading: shippingChargesLoading }, shippingChargesCall] =
    useAxios(
      {
        url: ECOMMERCE_API + '/shipping-charges',
        method: 'get',
      },
      { manual: true },
    )

  useEffect(() => {
    setLoader(updateUserLoading || shippingChargesLoading)
  }, [updateUserLoading, shippingChargesLoading])

  useEffect(() => {
    if (isShippingChargesEnabled) {
      shippingChargesCall()
    }
  }, [isShippingChargesEnabled])

  useEffect(() => {
    if (shippingChargesInfo && shippingChargesInfo.success && !isEmpty(shippingChargesInfo?.data)) {
      let tempStateData = []
      shippingChargesInfo?.data.forEach((element) => {
        tempStateData = [...tempStateData, ...element?.states]
      })

      setStatesData(tempStateData)
    }
  }, [shippingChargesInfo])

  useEffect(() => {
    if (!isEmpty(userObj?.eccom_address)) {
      setAddresses([...userObj.eccom_address])
    }
  }, [userObj])

  useEffect(() => {
    if (updateUserRes && updateUserRes.success) {
      validateSessionCall()
      raiseToast('success', 'Address updated successfully')
    }
  }, [updateUserRes])

  const updateAddressCall = (addressArr) => {
    updateUserCall({
      url: UPDATE_USER_INFO + '?user_id=' + userObj._id,
      method: 'put',
      data: {
        eccom_address: addressArr,
      },
    })
  }

  const addNewAddress = (newAddress) => {
    const addressWithId = {
      ...newAddress,
      id: uuidv4(),
    }
    setAddresses([...addresses, addressWithId])
    updateAddressCall([...addresses, addressWithId])
    setShowModal(false)
  }

  const updateAddress = (info) => {
    let tempAddresses = [...addresses]
    const index = tempAddresses.findIndex((addr) => addr.id === info.id)
    if (index !== -1) {
      tempAddresses[index] = info
      setAddresses(tempAddresses)
      updateAddressCall([...tempAddresses])
    }
    setShowModal(false)
    setEditAddress({})
  }

  const removeAddress = (index) => {
    const updatedAddresses = addresses.filter((address, idx) => idx !== index)
    setAddresses(updatedAddresses)
    updateAddressCall([...updatedAddresses])
  }

  const handleEdit = (item) => {
    setEditAddress(item)
    setShowModal(true)
    // let tempAddressArr = addresses
    // setEditAddress(addresses[index])
    // updateAddressCall([...updatedAddresses])
  }

  const handleDefaultAddress = (item, value) => {
    let tempAddresses = [...addresses]
    const index = tempAddresses.findIndex((addr) => addr.id === item.id)

    if (index !== -1) {
      tempAddresses = tempAddresses.map((addr, idx) =>
        idx !== index ? { ...addr, default: false } : { ...addr, default: value },
      )
      setAddresses(tempAddresses)
      updateAddressCall([...tempAddresses])
    }
  }

  return (
    <div className="w-full mt-2 xl:mt-4">
      <div className="flex justify-center px-3  md:px-6 items-center">
        <div>
          <div className="flex justify-between items-center mb-6 relative">
            <div className="flex items-center gap-2" onClick={() => setOpen(!open)}>
              <p className="text-white font-semibold text-sm md:text-lg lg:text-xl">
                Manage Addresses
              </p>
              {/* <img
                src={dropDownArror}
                alt={'dropDownArror'}
                className={`w-5 h-5 object-contain ml-auto transform transition-transform lg:hidden ${
                  open ? 'rotate-180' : ''
                }`}
              /> */}
            </div>
            <div className="flex gap-5 items-center">
              <div className="hidden lg:flex gap-5">
                <div
                  className="rounded px-6 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                  style={{
                    color: '#e3e2e2',
                    border: 'solid 1px #f60',
                  }}
                  onClick={() => navigate('/cart-details')}
                >
                  <img src={shoppingCart} alt="cart" className="w-4 h-4" />
                  <span>My Cart</span>
                </div>
                <div
                  className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                  style={{
                    color: '#e3e2e2',
                    border: 'solid 1px #f60',
                  }}
                  onClick={() => navigate('/order-history')}
                >
                  <img src={historyIcon} alt="bag" className="w-3 h-3" />
                  <span>Order History </span>
                </div>
                <div
                  className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                  style={{
                    color: '#e3e2e2',
                    backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                  }}
                  onClick={() => navigate('/store')}
                >
                  <img src={handBag} alt="bag" className="w-3 h-3" />
                  <span>Keep Shopping </span>
                </div>
              </div>
            </div>
            {open && (
              <div
                className="absolute top-full left-0 mt-2 w-full rounded-lg shadow-lg z-50 lg:hidden"
                style={{
                  backgroundColor: '#1d2a39',
                }}
              >
                <div className="flex flex-col gap-3 items-center mb-4 mt-3">
                  <div className="w-48">
                    <div
                      className="rounded px-5 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                      style={{
                        color: '#e3e2e2',
                        border: 'solid 1px #f60',
                      }}
                      onClick={() => navigate('/cart-details')}
                    >
                      <img src={shoppingCart} alt="cart" className="w-4 h-4" />
                      <span>My Cart</span>
                    </div>
                  </div>
                  <div className="w-48">
                    <div
                      className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                      style={{
                        color: '#e3e2e2',
                        border: 'solid 1px #f60',
                      }}
                      onClick={() => navigate('/order-history')}
                    >
                      <img src={historyIcon} alt="bag" className="w-3 h-3" />
                      <span>Order History</span>
                    </div>
                  </div>
                  <div className="w-48">
                    <div
                      className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                      style={{
                        color: '#e3e2e2',
                        backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                      }}
                      onClick={() => navigate('/store')}
                    >
                      <img src={handBag} alt="bag" className="w-3 h-3" />
                      <span>Keep Shopping </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Address Cards Container */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {/* .slice()
            .sort((a, b) => (b.default ? 1 : 0) - (a.default ? 1 : 0)) */}
            {addresses.map((item, index) => (
              <div
                key={index}
                className="rounded-[10px] p-5 flex flex-col"
                style={{
                  backgroundColor: '#1d2a39',
                  width: '300px',
                  minHeight: '275px',
                }}
              >
                {/* {item.default && (
                    <div>
                      <p className=" text-xs mb-1" style={{ color: '#979797' }}>
                        Default Address
                      </p>
                      <hr
                        className="p-0 mb-2"
                        style={{
                          border: '0.5px solid #707070',
                          marginLeft: '-1.2rem',
                          marginRight: '-1.2rem',
                        }}
                      />
                    </div>
                  )} */}
                <div className="flex-1">
                  <div className="flex items-center justify-between w-full  mb-3">
                    <p className="text-white font-semibold text-base line-clamp-1">{item.name}</p>
                    {/* {!item.default && ( */}
                    <div className=" flex items-center justify-end text-white">
                      <span className="text-[10px] font-semibold mr-2">Default</span>
                      <ToggleButton
                        enabled={item.default}
                        setEnabled={(value) => handleDefaultAddress(item, value)}
                        normalToggle={true}
                        enabledColorBg={'green'}
                        enabledToggle={'#00D100'}
                      />
                    </div>
                    {/* )} */}
                  </div>
                  <p className="text-sm  mb-2 leading-[1.57]" style={{ color: '#979797' }}>
                    {item.address},{item.city},{item.state},{item.zipcode}
                  </p>
                  <p className="text-sm mb-2 leading-[1.57]" style={{ color: '#979797' }}>
                    {item.country}
                  </p>
                  <p className="text-sm  mb-2 leading-[1.57]" style={{ color: '#979797' }}>
                    Phone Number : {item.phone}
                  </p>
                </div>

                <div className="flex justify-between mt-4">
                  <button
                    className="px-6 py-2 rounded text-sm flex items-center gap-2"
                    style={{ color: '#e3e2e2', border: 'solid 1px #f60' }}
                    onClick={() => removeAddress(index)}
                  >
                    <img src={deleteIcon} alt="delete" className="w-4 h-4" />
                    Remove
                  </button>

                  <button
                    className="px-6 py-2 rounded text-sm flex items-center gap-2"
                    style={{ color: '#e3e2e2', border: 'solid 1px #f60' }}
                    onClick={() => handleEdit(item)}
                  >
                    <img src={editIcon} alt="edit" className="w-4 h-4" />
                    Edit
                  </button>
                </div>
              </div>
            ))}

            {/* Add New Address Card */}
            <div
              className="rounded-[10px] p-5 flex flex-col items-center justify-center cursor-pointer"
              style={{
                border: 'dashed 1px #707070',
                width: '300px',
                minHeight: '275px',
              }}
              onClick={() => setShowModal(true)}
            >
              <img src={addIcon} alt="add" className="w-10 h-10 mb-3" />
              <p className="text-sm  leading-[1.57]" style={{ color: '#979797' }}>
                ADD NEW ADDRESS
              </p>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <AddAddressModal
          data={editAddress}
          onClose={() => setShowModal(false)}
          onSave={addNewAddress}
          onUpdate={updateAddress}
          isShippingChargesEnabled={isShippingChargesEnabled}
          statesData={statesData}
        />
      )}
    </div>
  )
}

export default ManageAddress
